import type { Message } from "@ag-ui/core";
import type { ReviewStatus } from "admin/types/interfaces/conversation";
import { apiClient, ApiError, isApiError } from "~/utils/apiClient";

const { VITE_ANALYSIS_AGENT_API } = import.meta.env;

export const adminConversationApiPath = (conversationId: string) =>
  `${VITE_ANALYSIS_AGENT_API}/admin/conversations/${conversationId}`;

export interface AdminConversationView {
  id: string;
  display_name: string;
  owner_display_name: string | null;
  created_at: string;
  review_status: ReviewStatus;
  messages: Message[];
}

export async function getAdminConversation(
  conversationId: string,
  options?: { signal?: AbortSignal }
): Promise<AdminConversationView | null> {
  try {
    return await apiClient<AdminConversationView>(adminConversationApiPath(conversationId), {
      signal: options?.signal,
    });
  } catch (err) {
    if (isApiError(err) && (err as ApiError).status === 404) return null;
    throw err;
  }
}
